// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gs67H","col":"styles_col__2qF-W"};